export enum PurchaseOrderFilterActionEnum {
  PurchaseOrderNo = 'PO No.',
  Product = 'Product'
}
